"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTranslate = void 0;
exports.defaultTranslate = {
    enquireSuccess: 'Success! Thanks for your enquiry! We will contact you soon!',
    searchSavedSuccess: 'Success! Your search has been saved',
    // tslint:disable-next-line:max-line-length
    searchSavedFailed: 'Sorry, we cannot save your search due to some technical problems. Please contact our Customer Service for details.',
    forRent: 'For Rent',
    forBuy: 'For Sale',
    nameMyAccount: 'My Account',
    // tslint:disable-next-line:max-line-length
    signupSuccess: 'Thank you for registering. You are almost ready to be part of our super-secret email updates! Please check your email to complete the verification process.',
    loginSuccess: 'You have successfully logged in!',
    logoutSuccess: 'You have successfully logged out!',
    failed: 'Something goes wrong :(',
    success: 'Success!',
    searchSavedDuplicated: 'Search Criteria already existed',
    noSavedLocation: 'No Saved Locations',
    pleaseAddLocation: 'Please add a location first',
    noRoute: 'No route to this location',
    verifyNow: 'Verify Now',
    deleteAccount: 'Are you sure?',
    deleteAccountCaption: 'Your Account will be removed',
    today: 'Today',
    yesterday: 'Yesterday',
    dayAgo: 'd',
    weekAgo: 'w',
    monthAgo: 'mo',
    yearAgo: 'yr',
    centuryAgo: 'ce',
    locationSaved: 'Location Saved',
    locationSavedCaption: 'You can view this building location in other building pages',
    locationSaveFailedCaption: 'Cannot save this building location',
    call: 'Call',
    email: 'Email',
    listPropertyFailed: 'Cannot list your property now, please try again later',
    savePlaceSuccess: 'Your place is saved',
    updateSuccess: 'Update Success',
    savePlaceFailed: 'Your place cannot be saved',
    message: 'Contact',
    close: 'Close',
    chinese: '中文',
    english: 'ENG',
    favSuccessView: 'You have saved this property to your favourite listing. Click <a href="{}" class="o-href">here</a> to view it any time!',
    learnMore: 'Learn More',
    guest: 'Guest',
    sucessSaveProperty: 'Successfully save a property',
    unsubscribeSuccess: 'Subscription update successfully',
    unsubscribeFailed: 'Unable to update subscription. Please contact us by phone',
    deleteUserSuccess: 'Delete user successfully',
    deleteUserFailed: 'Unable to delete user',
    copySuccessfully: 'Copy to clipboard succesfully',
    subscribeSuccess: 'You have subscribe to our newsletter',
    subscribeUnverified: 'Please check your email inbox to confirm your email address',
    subscribeDuplicated: 'Duplicated email',
    subscribeUnknown: 'Unable to subscribe. Please try again',
    invalidInput: 'Invalid Input',
    invalidEmail: 'Please enter a valid email to try again',
    pendingMessage: 'You have {} document(s) pending your signature',
    pendingTitle: 'Pending documents',
    reportSoldFailed: 'Report Sold Failed',
    reportSoldSuccess: 'Report Sold Success',
    notifyView: 'View',
    warning: 'Warning',
};
